import { t } from '@hefe/i18n';
import { Car, CarReservation } from '@hefe/models';
import { CarsSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CRUDComponent from '../../../crud/components/crud/crud.component';
import AddEditCarReservationForm from '../../forms/add-edit-car-reservation/add-edit-car-reservation.form';

export default function CarsReservationsPage() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const reservations = useSelector(CarsSlice.carsReservationsSelector);

  useEffect(() => {
    fetchReservations();
    fetchCars();
  }, []);

  const fetchCars = () => {
    dispatch(
      CarsSlice.fetchCars({
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };

  const fetchReservations = () => {
    setLoading(true);

    dispatch(CarsSlice.fetchCarsReservations())
      .unwrap()
      .finally(() => setLoading(false));
  };

  return (
    <CRUDComponent
      table={{
        name: 'cars-reservations',
        rowKey: 'id',
        loading: loading,
        columns: [
          {
            key: 'name',
            title: t('name'),
            dataIndex: 'name',
            showFilter: true,
            sortType: 'string',
            default: true,
          },
          {
            key: 'date_from',
            title: t('from'),
            dataIndex: 'date_from',
            showDateFilter: true,
            sortType: 'date',
            default: true,
            render: (date: string) => formatDateTime(date),
          },
          {
            key: 'date_to',
            title: t('till'),
            dataIndex: 'date_to',
            showDateFilter: true,
            sortType: 'date',
            default: true,
            render: (date: string) => formatDateTime(date),
          },
          {
            key: 'destination',
            title: t('cars.reservations.fields.destination'),
            dataIndex: 'destination',
            showFilter: true,
            sortType: 'string',
            default: true,
          },
          {
            key: 'car',
            title: t('cars.singular'),
            dataIndex: 'car',
            showFilter: true,
            sortType: 'string',
            default: true,
            render: (car: Car) => {
              return `${car.manufacturer} ${car.model} (${car.licence_plate})`;
            },
          },
        ],
        dataSource: reservations,
        addForm: {
          formId: 'add-edit-car-reservation-form-new',
          title: t('cars.reservations.create'),
          component: <AddEditCarReservationForm />,
        },
        disabledRowKeys: reservations
          .filter((r) => !r.reservation)
          .map((r) => r.id),
      }}
      updateComponent={{
        formId: 'add-edit-car-reservation-form',
        component: AddEditCarReservationForm,
        propKey: 'reservation',
        title: t('cars.reservations.edit'),
        disabled: (item: CarReservation) => !item.reservation,
      }}
      delete={{
        action: CarsSlice.deleteCarReservation,
        multiDelete: false,
      }}
    />
  );
}
